import request from "@/utils/request";

export default {
    // 制成基础列表查询
    getProcessBaseLists: (param) => {
        return request({
            url: `/processBase/processList`,
            method: "post",
            data: param,
        });
    },
    // 大类列表
    getProcessCategory: () => {
        return request({
            url: `/processBase/processCategoryList`,
            method: "post",
            data: {},
        });
    },
    // 新增大类
    addProcessCategory: (param) => {
        return request({
            url: `/processBase/addCategory`,
            method: "post",
            data: param,
        });
    },
    // 新增/编辑制成
    addOrUpdateProcess: (param) => {
        return request({
            url: `/processBase/addOrUpdateProcess`,
            method: "post",
            data: param,
        });
    },
    // 删除制成
    deleteProcess: (processId) => {
        return request({
            url: `/processBase/deleteProcess?processId=${processId}`,
            method: "get",
        });
    },
    // 批量删除制成
    batchDeleteProcess: (param) => {
        return request({
            url: `/processBase/batchDeleteProcess`,
            method: "post",
            data: param,
        });
    },
    // 制成指标列表查询
    getProcessIndicatorFactor: (param) => {
        return request({
            url: `/processIndicator/factorList`,
            method: "post",
            data: param,
        });
    },
    // 获取制成下拉
    getProcessIndicator: () => {
        return request({
            url: `/processIndicator/processList`,
            method: "post",
            data: {},
        });
    },
    // 新增/编辑指标
    addOrUpdatefactor: (param) => {
        return request({
            url: `/processIndicator/addOrUpdatefactor`,
            method: "post",
            data: param,
        });
    },
    // 删除指标
    deleteFactor: (factorId) => {
        return request({
            url: `/processIndicator/deleteFactor?factorId=${factorId}`,
            method: "get",
        });
    },
    // 批量删除指标
    batchDeleteFactor: (param) => {
        return request({
            url: `/processIndicator/batchDeleteFactor`,
            method: "post",
            data: param,
        });
    },
    // 新增/编辑指标参数
    addOrUpdateFactorParam: (param) => {
        return request({
            url: `/processIndicator/addOrUpdateFactorParam`,
            method: "post",
            data: param,
        });
    },
    // 指标参数列表
    getParamLists: (factorId) => {
        return request({
            url: `/processIndicator/getParamById?factorId=${factorId}`,
            method: "get",
        });
    },
    // 删除参数
    deleteParam: (paramId) => {
        return request({
            url: `/processIndicator/deleteParam?paramId=${paramId}`,
            method: "get",
        });
    },
    // 配置多值维度列
    addFactorColumn: (param) => {
        return request({
            url: `/processIndicator/addFactorColumn`,
            method: "post",
            data: param,
        });
    },
    // 多维列列表查询
    getFactorColumn: (factorId) => {
        return request({
            url: `/processIndicator/getFactorColumn?factorId=${factorId}`,
            method: "get",
        });
    },
    // 删除多值维度列表
    deleteFactorColumn: (columnId) => {
        return request({
            url: `/processIndicator/deleteFactorColumn?columnId=${columnId}`,
            method: "get",
        });
    },
    // 批量删除多值维度列表
    deleteFactorColumnList: (param) => {
        return request({
            url: `/processIndicator/deleteFactorColumnList`,
            method: "post",
            data: param,
        });
    },
    // 制造过程模板列表查询
    getProcessTemplateList: (param) => {
        return request({
            url: `/processTemplate/processTemplateList`,
            method: "post",
            data: param,
        });
    },
    // 新增模板制成参数列表查询
    getProcessParamList: (param) => {
        return request({
            url: `/processTemplate/processParamList`,
            method: "post",
            data: param,
        });
    },
    // 保存草稿制成
    saveDraftTemplate: (param) => {
        return request({
            url: `/processTemplate/saveOrUpdateTemplate`,
            method: "post",
            data: param,
        });
    },
    // 查看模板
    viewTemplate: (tplId) => {
        return request({
            url: `/processTemplate/viewTemplate?tplId=${tplId}`,
            method: "get",
        });
    },
    updateTemplateVersion: (tplId) => {
        return request({
            url: `/processTemplate/updateTemplateVersion?tplId=${tplId}`,
            method: "get",
        });
    },
};
